import { FC, ImgHTMLAttributes } from 'react';
import { SxProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

interface CoverImageProps extends ImgHTMLAttributes<HTMLImageElement> {
	sx?: SxProps<Theme>;
}

export const CoverImage: FC<CoverImageProps> = styled('img', {
	shouldForwardProp: (prop) => prop !== 'sx',
})(({ theme }) => ({
	width: '100%',
	display: 'block',
	height: '100%',
	objectFit: 'cover',
	objectPosition: 'center',
}));
